export default "__VITE_ASSET__uKDdk1_u__"